import styles from '../assets/styles/pages/OTP.module.scss';
import { Texts } from '../constants/Texts';
import { useEffect, useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import OtpInput from 'react-otp-input';
import classNames from 'classnames';
import { FixedSpace } from '../components/FixedSpace';
import { getMessage, generateCertification } from '../api/action';
import { ErrorPopup } from '../components/ErrorPopup';
import { useCustomerContext } from '../context/Customer';
import * as routes from '../routing/routes';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Button } from '../components/Button';

export const OTP = () => {
  const [code, setCode] = useState('');
  const customerContext = useCustomerContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname != customerContext.currentPosition) {
      customerContext.setCurrentPosition(routes.home);
      navigate(routes.home);
    }
  }, [pathname]);

  const sendCode = async () => {
    setLoading(true);
    const response = await generateCertification(
      code,
      customerContext.userData?.carNumber || '',
      customerContext.userData?.phoneNumber || '',
      customerContext.userData?.email || '',
      0
    );
    if (response) {
      if (response.properties.action_value !== '0') {
        if (!customerContext.checkTimer()) {
          customerContext.setCurrentPosition(routes.expiration);
          return;
        }
        const message = await getMessage(response.properties.action_value);
        setErrorText(String(message));
      } else {
        customerContext.setCode(code);
        customerContext.setCurrentPosition(routes.approval);
      }
    } else {
      console.error('error', response);
    }
    setLoading(false);
  };
  const [errorText, setErrorText] = useState('');
  const onClose = () => {
    setCode('');
  };

  useEffect(() => {
    if (customerContext.currentPosition != routes.otp) navigate(customerContext.currentPosition!);
  }, [customerContext.currentPosition]);

  return (
    <div className={styles.main}>
      <Sidebar firstHeader={Texts.ENTER_PASSWORD} secondHeader={Texts.PROTEXTION_CERTIFICATES} />
      <div className={styles.container}>
        <div className={styles.message}>{Texts.MESSAGE_SENT_AT_THIS_MOMENT}</div>
        <div className={styles.lightMessage}>{Texts.TYPE_THE_CODE}</div>
        <FixedSpace height={'2.6rem'} />
        <OtpInput
          value={code}
          onChange={setCode}
          numInputs={6}
          inputStyle={styles.inputs}
          containerStyle={styles.otpInputs}
          focusStyle={styles.focus}
          isInputNum={true}
        />
        <FixedSpace height={'2.6rem'} />
        <div className={styles.lightMessage}>{Texts.CODE_VALIDITY}</div>
        <FixedSpace height={'2.6rem'} />

        <div className={styles.btn}>
          <Button loading={loading} isValid={code.length === 6} onClick={sendCode} text={Texts.SEND} color='#ffcb1f' bgColor='#0f1337' />
          {/* <button onClick={sendCode} className={classNames(styles.sendBtn, code.length !== 6 && styles.disabled)}>
            {Texts.SEND}
          </button> */}
        </div>
      </div>
      {errorText.length ? <ErrorPopup text={errorText} setText={setErrorText} onClose={onClose} /> : <></>}
    </div>
  );
};
